import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useAuthStore } from '../store/useAuthStore';

/**
 * Mounts invisibly inside AuthProvider and keeps the Zustand auth store
 * in sync with AuthContext so components can subscribe to auth state
 * without prop drilling.
 */
export default function AuthSync() {
  const { user, isLoading } = useAuth();
  const setUser = useAuthStore((s) => s._setUser);
  const setLoading = useAuthStore((s) => s._setLoading);

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);
  useEffect(() => {
    setUser(user);
  }, [user, setUser]);

  return null;
}
